import React, { useState, useEffect } from 'react';
import { Group, Card, Text, Button, Stack, Checkbox } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';
import { theme } from '../consilitheme';
import { useGetUserSourceDataQuery } from '../endpoints/synthesis';
import EmptyPrompt from './EmptyPrompt';
import noInterestsLogo from '../assets/img/discovery_prompt_no_interests.svg';
import { ThreeCircles } from 'react-loader-spinner';

const UserPage = ({
  selectedUser,
  setIsUserPageOpen,
  updateSourceData,
  rerunAnalysis,
  showResponseError,
  showResponseValid,
  showResponseNoSources,
  showAnalyzing,
}) => {
  const userdata = useGetUserSourceDataQuery({ userid: selectedUser.id });

  const [sourceDatas, setSourceDatas] = useState([]);
  useEffect(() => {
    if (userdata.isSuccess) {
      setSourceDatas(
        [...userdata.data].sort(
          (a, b) => new Date(b.publication_date) - new Date(a.publication_date)
        ) ?? []
      );
    }
  }, [userdata]);
  return (
    <div>
      <Group mb={10}>
        <Text size="lg" fw={700}>
          User Operations for {selectedUser.username}
        </Text>

        <Button
          style={{ background: theme.colors.blue[4] }}
          ml="auto"
          onClick={() => setIsUserPageOpen(false)}
        >
          <IconCheck />
        </Button>
      </Group>
      <Button
        style={{ background: theme.colors.blue[4] }}
        ml="auto"
        mb={10}
        onClick={() => rerunAnalysis()}
      >
        Re-Run Analysis
      </Button>
      {showAnalyzing && (
        <Group justify="left" mb={10}>
          <ThreeCircles color={theme.colors.blue[4]} height={25} width={25} />
          <Text fw={700}>
            {' '}
            Waiting for analysis to be scheduled for {
              selectedUser.username
            }{' '}
            check #system-consili for the status
          </Text>
        </Group>
      )}
      {showResponseError && (
        <Text c="red" fw={700} size="md">
          Analysis could not be scheduled for {selectedUser.username} check
          #system-consili for the status
        </Text>
      )}

      {showResponseValid && (
        <Text c="darkgreen" fw={700} size="md">
          Analysis has been scheduled for {selectedUser.username} check
          #system-consili for the status
        </Text>
      )}
      {showResponseNoSources && (
        <Text c="red" fw={700} size="md">
          Please select sources!
        </Text>
      )}
      {sourceDatas.map((sourcedata) => (
        <Card
          padding="lg"
          radius="md"
          withBorder
          key={sourcedata.id}
          style={{ cursor: 'pointer' }}
          mb={10}
        >
          <Stack>
            <Group>
              <Text size="md" fw={700}>
                {sourcedata.title}
              </Text>
              <Text size="md" fw={700} ml="auto">
                {sourcedata.publication_date.split('T')[0]}
              </Text>
            </Group>
            <Text size="md" fw={400}>
              {sourcedata.summary ?? 'No summary currently available.'}
            </Text>
            <Group style={{ justifyContent: 'right' }}>
              <Text size="sm" fw={300}>
                Enable Re-Run
              </Text>
              <Checkbox onChange={() => updateSourceData(sourcedata)} />
            </Group>
          </Stack>
        </Card>
      ))}
      {sourceDatas.length == 0 && (
        <EmptyPrompt
          svgLink={noInterestsLogo}
          description="No source datas related to this user's interests"
        />
      )}
    </div>
  );
};

export default UserPage;
